import ImageWithPreviewModal from "@/modules/image-with-preview-modal";

const HeaderLogo = ({ path }) => {
  return (
    <ImageWithPreviewModal data-testid="header-logo" height={65} src={path} />
  );
};

export default HeaderLogo;
